export default {
    install(Vue, options) {
        Vue.prototype.$isAdmin = () => {
            return false
        };
    },
};